import { Box } from "@mui/material";
import styled from "styled-components";

export const RootContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.text.tertiary}`,
  padding: "32px 16px",
  display: "flex",
  flexDirection: "column",
  borderRadius: "4px",
  position: "relative",
}));

export const Label = styled(Box)<{ disabled?: boolean }>(
  ({ theme, disabled }) => ({
    padding: "5px",
    position: "absolute",
    top: 0,
    left: "10px",
    backgroundColor: theme?.palette.background.paper,
    transform: "translate(0, -50%)",
    color: disabled ? theme.palette.text.tertiary : theme.palette.text.primary,
  }),
);

export const LearnerVisibilityToggle = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "end",
}));

export const StakeholdersListContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
}));

export const AssociationModalContainer = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: theme.palette.background.paper,
  border: `2px solid ${theme.palette.divider}`,
  borderRadius: 10,
  paddingTop: 20,
  paddingLeft: 40,
  paddingRight: 40,
  paddingBottom: 30,
  width: "100vw",
  height: "100vh",
  overflow: "auto",
}));

export const AddButton = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  cursor: "pointer",
  borderBottom: `1px solid ${theme.palette.primary.main}`,
  alignSelf: "start",
  width: "fit-content",
  paddingBottom: "10px",
  userSelect: "none",
}));
